import { Button, Icon } from '@zoom/components';
import { FormApi } from 'final-form';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { getFilterInputResetTag, getFilterInputTag } from './constants';
import { AdherenceHistorySidebarFilterState, SidebarRadioFilterTile } from './types';
import { FinalFormFilterButton } from '../../components/FilterButton/FilterButton';
import { RadioFilter } from '../../types';

interface AdherenceHistoryRadioFilterTileProps {
  filter: SidebarRadioFilterTile;
  form: FormApi<AdherenceHistorySidebarFilterState>;
}

export const defaultRadioFilter: RadioFilter = undefined;

export const AdherenceHistoryRadioFilterTile: React.FC<AdherenceHistoryRadioFilterTileProps> = ({ filter, form }) => {
  const { t } = useTranslation();

  const { key } = filter;

  const handleReset = () => {
    form.change(key, defaultRadioFilter);
  };

  return (
    <>
      <div className="radio-filter-tile__wrapper d-flex flex-column">
        {filter.options.map((option) => (
          <Field
            key={`${key}-${option.value}`}
            name={key}
            type="radio"
            value={option.value}
            component={FinalFormFilterButton}
            dataTestId={getFilterInputTag(`${key}-${option.label}`, filter.filterInputType)}
          >
            {option.label}
          </Field>
        ))}
      </div>

      {form.getFieldState(key)?.value && (
        <div className="radio-filter-tile__reset">
          <Button
            className="p-2"
            data-test-id={getFilterInputResetTag(key, filter.filterInputType)}
            kind="icon"
            onClick={handleReset}
          >
            <Icon kind="cross" size={15} color="grey3" className="mr-2" />
            {t('filter.reset')}
          </Button>
        </div>
      )}
    </>
  );
};
